<template>
    <scroll-content :distance="300" @scroll="scrollHandler">
        <!-- @scroll="scrollHandler" -->
        <notice-empty v-if="isNotFound">
            <div><awesome-icon name="minus-circle" /></div>
            <st-divider :between="1.4">{{ isNotFound }}</st-divider>
            <st-link back color="primary">뒤로가기</st-link>
        </notice-empty>

        <school-detail :detail="detail" :loading="loading.detail" @follow="followHandler" />
        <!-- :banner="banner" -->

        <common-list-template
            school
            :todos="todos"
            :loading="todoLoading"
            :isLast="isNoticeLast"
            @get-more="getMoreItemHandler"
            @keeping="keepingHandler"
        />
    </scroll-content>
</template>
<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { dataEncoded, copy } from "../../../utils/lib";

import ScrollContent from "../../../components/ScrollContent";
import { NoticeEmpty } from "../../../components/palette";
import SchoolDetail from "../components/SchoolDetail";
import CommonListTemplate from "../../notice/components/CommonListTemplate";

export default {
    name: "SchoolContainer",
    data: () => ({
        id: null,
        type: "notice",
        boardId: null,
        // banner: false,
        unwatch: null,
        scrollTop: 0
    }),
    computed: {
        ...mapState("user", {
            token: "token"
        }),

        ...mapState("notice", {
            typeIconV3: "typeIconV3"
        }),

        ...mapState("school", {
            loading: "loading",
            detail: "detail",
            pages: "pages",
            fixedScroll: "fixedScroll",
            isNotFound: "isNotFound",
            isNoticeLast: "isNoticeLast",
            schoolBoards: "schoolBoards",
            schoolBoardsLoading: "schoolBoardsLoading"
        }),

        ...mapGetters("school", {
            eachSchoolMenu: "eachSchoolMenu",
            getBoardId: "getBoardId"
        }),

        routeType() {
            // 최초 1회 입장시
            if (this.getBoardId.length === 0 || !this.boardId) return null;

            // newsfeed 에서 넘어오면 boardId 가 없다.
            const uniqueFind = this.getBoardId.find(({ id }) => id === this.boardId);
            if (!uniqueFind) return null;

            return uniqueFind.uid;
        },

        todos() {
            if (this.getBoardId.length === 0) return [];
            // getBoard 는 초기에 없고 detail을 불러오면 생김
            const uid = this.routeType ? this.routeType : this.getBoardId[0].uid;
            return this.schoolBoards[uid];
        },

        todoLoading() {
            if (this.getBoardId.length === 0) return false;
            const uid = this.routeType ? this.routeType : this.getBoardId[0].uid;
            return this.schoolBoardsLoading[uid];
        }
    },
    methods: {
        ...mapMutations("notice", ["SET_DO_KEEPING"]),

        ...mapMutations("school", [
            "SET_PAGE",
            "SET_PAGES",
            "SET_IS_NOT_FOUND",
            "SET_SCHOOL",
            "SET_DETAIL_FOLLOW",
            "SET_SCHOOL_CLEAR",
            "SET_BOARD_CLEAR",
            "SET_IS_NOTICE_LAST",
            "SET_DO_KEEPING",
            "SET_AFTER_FOLLOW",
            "SET_FIXED_SCROLL"
        ]),

        ...mapActions("school", ["GET_SCHOOL_DETAIL", "DO_FOLLOW", "GET_SCHOOL_NEWS_FEED"]),

        // ! not used 학교 스크롤 배너 2020 7월 13일
        scrollHandler(el) {
            // const { offsetHeight, scrollTop } = el;

            this.scrollTop = el.scrollTop;

            // if (offsetHeight + scrollTop >= 1150 && !this.banner) {
            //     this.banner = true;
            // }

            // if (offsetHeight + scrollTop < 1150 && this.banner) {
            //     this.banner = false;
            // }
        },

        followHandler(type) {
            this.DO_FOLLOW({
                $alert: this.$alert,
                type: type === 0 ? 1 : 2,
                schoolId: this.id,
                name: this.detail.name,
                hook: () => {
                    this.SET_DETAIL_FOLLOW(type === 0 ? 1 : 0); // 0 취소 1 구독
                    this.SET_AFTER_FOLLOW({ schoolId: this.$route.params.id, type: type === 0 ? 1 : 2 }); // 2 취소, 1 구독
                }
            });
        },

        keepingHandler({ articleIdx, next }) {
            this.SET_DO_KEEPING({ articleIdx, next, boardId: this.boardId });
        },

        initialize() {
            this.id = this.$route.params.id;
            this.SET_IS_NOT_FOUND(null);

            this.GET_SCHOOL_DETAIL({
                $alert: this.$alert,
                $router: this.$router,
                schoolId: this.id,
                boardId: this.boardId
            });
        },

        getMoreItemHandler() {
            // ! 주의 요망 문제가 있을 수 있음
            // * newsfeed 에서 스크롤을 하고 school로 넘어오면 자동으로 top 이 올라간다.
            // * 이에 따라 scroll 이벤트가 자동 동작하고 이떼 getMoreItemHandler 가 동작한다.
            if (!this.todoLoading && this.todos.length !== 0) {
                const nextPage = this.pages[this.routeType] + 1;
                this.SET_PAGE({ type: this.routeType, page: nextPage });
                this.routeNoticeHandler();
            }
        },

        fixedScrollMemorized() {
            console.log(this.scrollTop);
            this.SET_FIXED_SCROLL({ type: this.routeType, scroll: this.scrollTop });
        },

        scrollTo() {
            setTimeout(() => {
                const container = document.querySelector("#container");
                container.scrollTop = this.fixedScroll[this.routeType];
            }, 100);
        },

        routeNoticeHandler() {
            const params = {
                $alert: this.$alert,
                schoolId: this.id,
                boardId: this.boardId,
                uid: this.routeType,
                loading: true
            };

            // type = 리스트 카테고리 (en)
            this.GET_SCHOOL_NEWS_FEED(params);
        }
    },
    watch: {
        $route(to, from) {
            this.fixedScrollMemorized();
            // 학교 이동시에만
            if (to.params.id !== from.params.id) {
                this.SET_PAGE({ type: this.routeType, page: 1 });
                this.SET_SCHOOL(null);
                this.SET_BOARD_CLEAR("all");
                this.SET_SCHOOL_CLEAR("school");
                this.boardId = null;
                this.initialize();
            }
            // 학교이름 클릭시 자동으로 공지사항 가져오기
            if (to.params.type && !from.params.type) {
                this.boardId = to.params.type;
                this.initialize();
            }
            // 게시글 이동시에만
            if (to.params.type && to.params.type !== from.params.type) {
                this.SET_IS_NOTICE_LAST(false);
                this.SET_SCHOOL_CLEAR("school");
                // this.SET_PAGE({ type: this.routeType, page: 1 });
                // this.SET_BOARD_CLEAR(to.params.type);
                // type = boardId
                this.boardId = to.params.type;

                this.scrollTo();

                // 리스트가 없을때만 초기 렌더링
                if (this.todos.length === 0) {
                    this.routeNoticeHandler();
                }
            }
        }
    },

    created() {
        this.boardId = this.$route.params.type;

        if (this.routeType) {
            this.scrollTo();
        }

        if (this.token) {
            if (this.todos.length === 0) {
                this.initialize();
                return;
            }
        }

        // 새로고침시 token 을 상실 하기 때문에 바뀌면 가져온다.
        this.unwatch = this.$store.watch(
            state => state.user.token,
            val => {
                if (!val) return;
                if (this.todos.length === 0) {
                    this.initialize();
                }
            }
        );
    },

    beforeDestroy() {
        const path = this.$route.path;

        if (!/(school|article)/g.test(path)) {
            this.id = null;
            this.boardId = null;
            this.SET_SCHOOL(null);
            this.SET_SCHOOL_CLEAR("school");
            this.SET_BOARD_CLEAR("all");

            this.unwatch && this.unwatch();
            return;
        }

        this.fixedScrollMemorized();
    },
    components: {
        ScrollContent,
        NoticeEmpty,
        CommonListTemplate,
        SchoolDetail
    }
};
</script>
